export default __webpack_public_path__ + "static/media/image14.edc360e0.png";